@if (control.invalid && control.errors && (control.dirty || control.touched || submitted)) {
  @if (control.hasError('required')) {
    <span class="error_msg">
      Bitte füllen Sie dieses Feld aus
    </span>
  }
  @if (control.hasError('requiredTrue')) {
    <span class="error_msg">
      Bitte bestätigen Sie diese Bedingung
    </span>
  }
  @if (control.hasError('email')) {
    <span class="error_msg">
      Bitte geben Sie eine gültige E-Mail Adresse an
    </span>
  }
}
